import React from 'react';
import { AssuranceStatusBadge } from './AssuranceStatusBadge';
import { SurveyModelMinimalUtrv } from '@g17eco/types/survey';
import { NotApplicableBadge } from './NotApplicableBadge';
import { StatusBadge } from './StatusBadge';
import { PrivacyBadge } from './PrivacyBadge';
import { AIExcludedBadge } from './AIExcludedBadge';
import classNames from 'classnames';
import { InitiativeUniversalTracker } from '@g17eco/types/initiativeUniversalTracker';
import { isExcludedFromAiProcessing } from '@utils/initiative-universal-tracker';

interface QuestionStatusDisplayProps {
  utrv: SurveyModelMinimalUtrv | undefined;
  isPrivate: boolean | undefined;
  initiativeUtr?: InitiativeUniversalTracker;
  className?: string;
}

export const QuestionStatusDisplay: React.FC<QuestionStatusDisplayProps> = ({
  utrv,
  isPrivate,
  initiativeUtr,
  className,
}) => {
  if (!utrv) {
    return null;
  }

  const showAIExcluded = isExcludedFromAiProcessing(initiativeUtr);

  return (
    <div
      className={classNames('question__status d-flex align-items-center justify-content-between', className)}
      data-testid='question-status-badge'
    >
      <AssuranceStatusBadge utrv={utrv} />
      <div className='w-100 d-flex justify-content-end'>
        {showAIExcluded ? <AIExcludedBadge className='ml-2' /> : null}
        <PrivacyBadge isPrivate={isPrivate} className='ml-2' />
        <StatusBadge utrv={utrv} className='ml-2' />
        <NotApplicableBadge utrv={utrv} showExplanation={false} className='ml-2' />
      </div>
    </div>
  );
};
